<div class="hw-box-content">
    <div class="hw-header-wrap">
      <div class="row">
        <div class="col-6">
          <i class="fn-global-site"></i>
          {{ 'Server Health' | translate }}
        </div>
        <div class="col-6 text-right">
            <a class="btn btn-link" (click)="getSwaggerUrl()">Rest API</a>
            <a class="btn btn-link" (click)="getMonitoring()">JPA Monitoring</a>
        </div>
      </div>
    </div>
    <div class="hw-content">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Server Start Time' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.serverStartTime }} ({{ objectHash.uptime }})</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Host Name' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.hostname }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'IP Address' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.ipAddress }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Logged In Users' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.loggedInUserCount }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Current Server Time' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.currentServerTime }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Tomcat Version' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.tomcatVersion }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Number of Thread' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.threadCount | number }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Total Memory' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.totalMemory }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'Used Memory' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.usedMemory }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <h3 class="blue">{{ 'CPU Usage' | translate }}</h3>
            </div>
            <div class="col-md-8">
              <h3 class="blue">{{ objectHash.cpuUsagePercentage | number }} %</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  